<template>
  <div>
    <!-- Google map -->
    <div id="map" class="w-100"></div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  props: {
    location: Object,
  },

  data() {
    return {
      map: null,
      isMapLoaded: false,
    };
  },

  async mounted() {
    console.log(this.location);
    this.loadMyMap();
  },

  watch: {
    location: function () {
      if (this.location && !this.isMapLoaded) {
        this.loadMyMap();
        this.isMapLoaded = true;
      }
    },
  },

  methods: {
    async loadMyMap() {
      if (this.location && !this.isMapLoaded) {
        this.isMapLoaded = true;
        const loader = new Loader({
          apiKey: "AIzaSyAsjTYlNYOvHXj8GV72iYJjxbit6eMGt1U",
          version: "weekly",
        });

        const lat = parseFloat(this.location.centerLatitude).toFixed(3);
        const long = parseFloat(this.location.centerLongitude).toFixed(3);

        loader
          .load()
          .then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
              center: {
                lat: parseFloat(lat),
                lng: parseFloat(long),
              },
              zoom: 10,
              streetViewControl: false,
              mapTypeControl: false,
              styles: [
                {
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.country",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "off",
                    },
                  ],
                },
                {
                  featureType: "road",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  stylers: [{ hue: "#00ffe6" }, { saturation: -20 }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ lightness: 100 }, { visibility: "simplified" }],
                },
                {
                  featureType: "road",
                  elementType: "labels",
                  stylers: [{ visibility: "off" }],
                },
              ],
            });

            this.loadRoute();
            // const trafficLayer = new google.maps.TrafficLayer();
            // trafficLayer.setMap(this.map);
          })
          .catch((e) => {
            console.error(e);
            this.isMapLoaded = false;
          });
      }
    },

    loadRoute() {
      if (this.location) {
        var start = new google.maps.LatLng(
          parseFloat(this.location.startLatitude),
          parseFloat(this.location.startLongitude)
        );
        var end = new google.maps.LatLng(
          parseFloat(this.location.endLatitude),
          parseFloat(this.location.endLongitude)
        );

        var directionsDisplay = new google.maps.DirectionsRenderer(); // also, constructor can get "DirectionsRendererOptions" object
        directionsDisplay.setMap(this.map); // map should be already initialized.
        directionsDisplay.setOptions({
          polylineOptions: {
            strokeColor: "#0275d8",
            strokeOpacity: 0.8,
            strokeWeight: 8,
          },
        });

        var request = {
          origin: start,
          destination: end,
          travelMode: google.maps.TravelMode.DRIVING,
        };

        var directionsService = new google.maps.DirectionsService();
        directionsService.route(request, function (response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
          }
        });
      }
    },

    drawPolyline(startLat, startLong, endLat, endLong) {
      var coordinates = [
        { lat: parseFloat(startLat), lng: parseFloat(startLong) },
        { lat: parseFloat(endLat), lng: parseFloat(endLong) },
      ];

      new google.maps.Polyline({
        map: this.map,
        path: coordinates,
        geodesic: true,
        strokeColor: "#000",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
    },
  },
};
</script>

<style scoped>
#map {
  /* width: 50%; */
  height: 50vh;
  margin: 0;
  padding: 0;
  border-radius: 5px;
}

#direction {
  color: #000;
  max-width: 99%;
  width: 300px;
  position: absolute;
  z-index: 999;
  font-size: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  outline: none !important;
  top: 55px;
  border-radius: 10px;
  margin: 2px 4px;
}

#mLogo0 {
  display: none !important;
}

.map-default {
  position: absolute;
  left: 1.5%;
  top: 3%;
}
</style>
